import { type JSONObject, Temporal } from '@imago/api-client'
import { type MimeType, type GDrive_FileID, type GDrive_FolderID } from '@imago/api-client-google-workspace'

export { type MimeType }

export const Folder_MimeType = 'application/vnd.google-apps.folder' as MimeType
export const Document_MimeType = 'application/vnd.google-apps.document' as MimeType

const UserID__Brand: unique symbol = Symbol()
export type UserID = GDrive_FolderID & {[UserID__Brand]: never}

const FileID__Brand: unique symbol = Symbol()
export type FileID = GDrive_FileID & {[FileID__Brand]: never}

export type EMRID = `${UserID}/${FileID}`

const EMRKindID__Brand: unique symbol = Symbol()
export type EMRKindID = string & {[EMRKindID__Brand]: never}

const EMRTypeID__Brand: unique symbol = Symbol()
export type EMRTypeID = string & {[EMRTypeID__Brand]: never}

export type EncounterStatus = 'scheduled' | 'ready' | 'done' | 'closed' | 'no-show' | 'cancelled'

export interface EMRInfo {
	ID: EMRID
	timestamp: Temporal.Instant
	kindID: EMRKindID
	mimeType: MimeType

	patientID: UserID
	fileID: FileID
	type: EMRTypeID
	callStatus: EncounterStatus | undefined
	hasWelcomed: boolean
	hasRecommendation: boolean
}

export function parseEMRID(ID: EMRID) {
	const v = ID.split('/') as [UserID, FileID]
	return {
		patientID: v[0],
		fileID: v[1],
	}
}

export interface EMRInfoJSON extends JSONObject {
	ID: EMRID
	timestamp: Temporal.Instant_ISO
	kindID: EMRKindID
	mimeType: MimeType

	patientID: UserID
	fileID: FileID
	type: EMRTypeID
	callStatus: EncounterStatus | undefined
	hasWelcomed: boolean
	hasRecommendation: boolean
}

export function serializeEMR(emr: EMRInfo): EMRInfoJSON {
	return {
		...emr,
		timestamp: emr.timestamp.toString(),
	}
}

export function deserializeEMR(emr: EMRInfoJSON): EMRInfo {
	return {
		...emr,
		timestamp: Temporal.Instant.from(emr.timestamp),
	}
}
